"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTooltipText = exports.StyledTooltipLabel = exports.StyledTooltipContent = exports.StyledArrow = exports.StyledTooltip = exports.StyledHintIcon = exports.IconContainer = exports.StyledTooltipBox = exports.StyledRoot = void 0;
const theme_1 = require("@pulse-web-ui/theme");
exports.StyledRoot = theme_1.styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 103;
`;
exports.StyledTooltipBox = theme_1.styled.div ``;
exports.IconContainer = theme_1.styled.div `
  height: ${({ height }) => height || '22'}px;
  width: ${({ width }) => width || '22'}px;
`;
exports.StyledHintIcon = theme_1.styled.span ``;
exports.StyledTooltip = theme_1.styled.div `
  ${theme_1.typography.regular14};
  position: absolute;
  width: 248px;
  padding: 12px;
  box-sizing: border-box;
  transition: 0.24s cubic-bezier(0.24, 0.1, 0.24, 1);
  transition-property: visibility, opacity;
  line-height: 20px;
  z-index: 10;
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 2)`; }};
  ${({ theme }) => theme.common['box-shadow']};
  background: ${({ theme }) => theme.colors.neutral[0]};
  color: ${({ theme }) => theme.colors.text.secondary};

  &[data-popper-placement='top'] > [data-popper-arrow] {
    bottom: -4px;
  }

  &[data-popper-placement='bottom'] > [data-popper-arrow] {
    top: -4px;
  }

  &[data-popper-placement='left'] > [data-popper-arrow] {
    right: -4px;
  }

  &[data-popper-placement='right'] > [data-popper-arrow] {
    left: -4px;
  }

  &[data-popper-reference-hidden] {
    visibility: hidden;
    opacity: 0;
  }

  z-index: ${({ placement }) => placement && '103'};

  ${({ visible }) => visible &&
    (0, theme_1.css) `
      opacity: 1;
      visibility: visible;
    `}
`;
exports.StyledArrow = theme_1.styled.div `
  position: absolute;
  width: 12px;
  height: 12px;
  z-index: -1;
  background: transparent;

  &:before {
    position: absolute;
    width: 12px;
    height: 12px;
    z-index: -1;
    background: ${({ theme }) => theme.colors.neutral[0]};
    content: '';
    transform: rotate(45deg);
  }
`;
exports.StyledTooltipContent = theme_1.styled.div `
  display: flex;
  flex-direction: column;
`;
exports.StyledTooltipLabel = theme_1.styled.label `
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 4px;
`;
exports.StyledTooltipText = theme_1.styled.span ``;
